export default __webpack_public_path__ + "static/pria-e85a3baa8bf24628dcb481f313f87175.png";